var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.0756 72H7.92488C3.56708 72 0 68.4329 0 64.0751V7.92485C0 3.56707 3.56708 0 7.92488 0H64.0756C68.4333 0 72 3.56707 72 7.92485V64.0751C72 68.4329 68.4333 72 64.0756 72Z",
    fill: "#0057B8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9928 57.9585C48.1187 57.9585 57.9489 48.1286 57.9489 36.0027C57.9489 23.8768 48.1187 14.0469 35.9928 14.0469C23.8669 14.0469 14.0371 23.8768 14.0371 36.0027C14.0371 48.1286 23.8669 57.9585 35.9928 57.9585Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6675 9.75977L44.902 36.0031",
    stroke: "#729CC4",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6675 62.2375L44.902 36.0029",
    stroke: "#729CC4",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLearn);
export default __webpack_public_path__ + "static/media/eyeLearn.e46d4ae788c9796ca269df711e1db5c9.svg";
export { ForwardRef as ReactComponent };